export default "__VITE_ASSET__DLROTJaU__"